import { RootState } from '../config/Store';

export const getPresenceState = (rootState: RootState) => rootState.presence.state;
